<template>
  <ItemWrapper @openChildEditor="handleOpenChildEditor">
    <div class="content-item" :class="[clickLink.isActive && 'click-link', align]" @click="handleClick">
      <div class="media-container">
        <img v-if="media.isImage" class="image" :src="media.src"/>
        <video v-else class="video" controls :poster="media.coverImage" :src="media.src">
          {{ $t('microSite.mediaAndText.notSupportVideo') }}
        </video>
      </div>
      <div v-if="title || content" class="text-container">
        <div class="title" :class="!title && 'no-wrapper'">
          <div class="title-text module-text-subtitle" ref="titleEl">{{ title }}</div>
        </div>
        <div class="content">
          <div class="content-text ql-editor module-text-content" ref="contentEl" v-html="checkedContentHtml"></div>
        </div>
      </div>
    </div>
  </ItemWrapper>
</template>

<script>
import ItemWrapper from '../../../components/render/itemWrapper'
import { mapGetters } from 'vuex'
import { mixedRouterPush } from '@/router/routes'
import { appendSourceCode } from '@/utils/common'
import { CHILD_EDITOR_NAME, CHILD_RENDER_NAME } from '../constant'

export default {
  name: CHILD_RENDER_NAME,
  components: {
    ItemWrapper
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: 'align-top'
    },
    content: {
      type: String,
      default: ''
    },
    media: {
      type: Object,
      required: true
    },
    clickLink: {
      type: Object,
      required: true
    },
    styleConfig: {
      type: Object,
      required: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('microSite', ['isEditMode', 'currentPage', 'pagePathPrefix']),
    checkedContentHtml () {
      return this.checkContent(this.content)
    }
  },
  created () {

  },
  methods: {
    checkContent (content) {
      // to-do may need to check some danger html code
      return content
    },
    handleOpenChildEditor () {
      this.$emit('openChildEditor', {
        editorName: CHILD_EDITOR_NAME,
        fromChild: true
      })
    },
    handleClick () {
      if (!this.clickLink.isActive) {
        return
      }
      this.clickLink.url = this.clickLink.url.trim()
      if (this.clickLink.url.startsWith('/v/onboarding/questionnaire')) {
        this.$eventBus.$emit('openOnboardingQuestionnairePage', this.clickLink.openNewWindow)
        return
      }
      let targetUrl = null
      if (this.clickLink.isInnerPage) {
        targetUrl = this.pagePathPrefix + this.clickLink.url
      } else {
        targetUrl = this.clickLink.url
      }
      targetUrl = appendSourceCode(targetUrl)
      if (this.clickLink.openNewWindow) {
        window.open(targetUrl)
      } else {
        if (this.clickLink.isInnerPage) {
          this.$router.push(targetUrl)
        } else {
          mixedRouterPush(targetUrl)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-item {
  &.click-link {
    cursor: pointer;
  }

  .media-container {
    display: flex;
    flex-direction: column;

    .image {
      display: block;
      max-width: 100%;
    }

    .video {
      display: block;
      margin: auto;
      max-width: 100%;
      object-fit: fill;
    }
  }

  .text-container {
    display: flex;
    flex-direction: column;

    .title {
      margin-bottom: 20px;
    }

    .content {
      .content-text{
        word-break: break-word;
        padding: 0;
      }
    }
  }

  &.align-center {
    .media-container,
    .text-container {
      justify-content: center;
    }
  }

  &.align-bottom {
    .media-container,
    .text-container {
      justify-content: flex-end;
    }
  }
}

.mobile {
  .content-item {
    .text-container {
      margin-top: 20px;
    }
  }
}
</style>
